(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["vine-header"]) return;
  try {
    
document.addEventListener('click',function(event){if(event.target.closest('.vh-mobile-nav a')){const menu=event.target.closest('details');if(menu)menu.open=false;}});
document.addEventListener('keydown',function(event){if(event.key==='Escape'){document.querySelectorAll('.vh-mobile-nav[open]').forEach(menu=>{menu.open=false;menu.querySelector('summary').focus();});}});

  } catch(e) { console.error(e); }
})();
})();
